'use strict';
// =================================================================
//  MAC-020 PLP Card Redesign — Image Swap
//  Lee data-mco-alt-img inyectado server-side desde el snippet Liquid.
//  No hace fetch a /products/{handle}.js — la URL ya viene resuelta.
// =================================================================

var MCO_PLP = {
  SELECTORS: {
    card:   'product-card.mco-crd--active',
    figure: 'figure.product-featured-image'
  },
  TIMING: {
    fadeDur:     180,
    entryDur:    250,
    hoverDelay:  200,
    swipeThresh: 40,
    swipeRatio:  2
  },
  activeSwapFigure: null
};

function mcoPlpSwapTo(figure, url) {
  if (figure.querySelector('.mco-overlay')) return;

  // Exclusividad mutua: restaurar la figure activa antes de activar esta
  if (MCO_PLP.activeSwapFigure && MCO_PLP.activeSwapFigure !== figure) {
    mcoPlpSwapBack(MCO_PLP.activeSwapFigure);
  }
  MCO_PLP.activeSwapFigure = figure;

  var overlay = document.createElement('div');
  overlay.className = 'mco-overlay';

  var img = document.createElement('img');
  img.alt = '';

  // Estado inicial via cssText inline SIN transition. El tema tiene scroll-animation
  // que resetea opacity:0 en imgs con transition CSS — añadimos transition solo
  // al activar, tras forzar reflow.
  img.style.cssText = 'width:100%;height:100%;display:block;opacity:0;transform:scale(1.03);';

  var activated = false;
  function activate() {
    if (activated || overlay._mcoCancelled) return;
    activated = true;
    void img.offsetHeight; // reflow síncrono
    img.style.transition = 'opacity ' + MCO_PLP.TIMING.entryDur + 'ms ease-out, transform ' + MCO_PLP.TIMING.entryDur + 'ms ease-out';
    img.style.opacity   = '1';
    img.style.transform = 'scale(1)';
  }

  img.addEventListener('load', activate);
  img.addEventListener('error', function () {
    overlay._mcoCancelled = true;
    mcoPlpSwapBack(figure);
  });
  img.src = url;

  overlay.appendChild(img);
  figure.appendChild(overlay);
  figure.classList.add('mco-swapped');

  if (img.complete && img.naturalWidth > 0) activate();
  mcoPlpUpdateDots(figure, 1);
}

function mcoPlpSwapBack(figure) {
  var overlay = figure.querySelector('.mco-overlay');
  if (!overlay) return;

  overlay._mcoCancelled = true;
  if (MCO_PLP.activeSwapFigure === figure) MCO_PLP.activeSwapFigure = null;

  var img = overlay.querySelector('img');
  if (img) {
    img.style.transition = 'opacity ' + MCO_PLP.TIMING.fadeDur + 'ms ease-in';
    img.style.opacity   = '0';
  }

  figure.classList.remove('mco-swapped');
  mcoPlpUpdateDots(figure, 0);
  setTimeout(function () {
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }, MCO_PLP.TIMING.fadeDur);
}

function mcoPlpUpdateDots(figure, idx) {
  var dots = figure.querySelectorAll('.mco-dot');
  for (var i = 0; i < dots.length; i++) {
    dots[i].classList.toggle('mco-dot--active', i === idx);
  }
}

function mcoPlpAttachCard(card) {
  if (card.dataset.mcoSwapInit) return;
  card.dataset.mcoSwapInit = '1';

  var altUrl = card.getAttribute('data-mco-alt-img');
  if (!altUrl) return; // producto sin imagen alternativa — sin swap, sin dots

  var figure = card.querySelector(MCO_PLP.SELECTORS.figure);
  if (!figure) return;

  // Preload de la alt-img para evitar flash blanco en el primer swap
  var preload = new Image();
  preload.src = altUrl;

  // Desktop: hover con intent delay
  var hoverTimer;
  figure.addEventListener('mouseenter', function () {
    hoverTimer = setTimeout(function () {
      mcoPlpSwapTo(figure, altUrl);
    }, MCO_PLP.TIMING.hoverDelay);
  });
  figure.addEventListener('mouseleave', function () {
    clearTimeout(hoverTimer);
    mcoPlpSwapBack(figure);
  });

  // Mobile: swipe horizontal con toggle bidireccional
  var touchStartX, touchStartY, swiped;
  figure.addEventListener('touchstart', function (e) {
    clearTimeout(hoverTimer); // iOS/Android sintetizan mouseenter al tap
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    swiped = false;
  }, { passive: true });

  figure.addEventListener('touchmove', function (e) {
    if (swiped) return;
    var dx = Math.abs(e.touches[0].clientX - touchStartX);
    var dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > MCO_PLP.TIMING.swipeThresh && dx > dy * MCO_PLP.TIMING.swipeRatio) {
      swiped = true;
      if (figure.querySelector('.mco-overlay')) {
        mcoPlpSwapBack(figure);
      } else {
        mcoPlpSwapTo(figure, altUrl);
      }
    }
  }, { passive: true });
}

function mcoPlpProcessAll() {
  var cards = document.querySelectorAll(MCO_PLP.SELECTORS.card + '[data-mco-alt-img]');
  for (var i = 0; i < cards.length; i++) {
    mcoPlpAttachCard(cards[i]);
  }
}

function mcoPlpDebounce(fn, delay) {
  var timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
}

function mcoPlpSetupObserver() {
  // Re-aplica listeners a cards inyectadas dinámicamente (filtros, paginación AJAX, etc.)
  var debounced = mcoPlpDebounce(mcoPlpProcessAll, 200);
  var observer = new MutationObserver(debounced);
  observer.observe(document.body, { childList: true, subtree: true });
}

function mcoPlpInit() {
  if (!document.querySelector(MCO_PLP.SELECTORS.card)) return;
  mcoPlpProcessAll();
  mcoPlpSetupObserver();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mcoPlpInit);
} else {
  mcoPlpInit();
}